<template>
  <div class="input-field-wrapper" :class="computedClass">
    <div class="input-field-group">
      <div class="text-input">
        <input
            v-if="distinctive"
            :id="id"
            :type="type"
            :placeholder="placeholder"
            :value="inputValue"
            autocomplete="off"
            @input="inputChanged"
            @keyup="$emit('keyup', $event)"
            @change="$emit('change', $event)"
            @blur="$emit('blur', $event)"
            :maxlength="maxLength"
            :valid="invalidField"
            :pattern="pattern"
            :title="title"
            :required="required"
            class="font-size-middle"
        />
        <input
            v-else
            :id="id"
            :type="type"
            :placeholder="placeholder"
            :value="value"
            autocomplete="off"
            @input="inputChanged"
            @keyup="$emit('keyup', $event)"
            @change="$emit('change', $event)"
            @blur="$emit('blur', $event)"
            @click="handleClick"
            :maxlength="maxLength"
            :valid="invalidField"
            :pattern="pattern"
            :title="title"
            :required="required"
            class="font-size-middle"
        />
        <label class="font-size-middle" :for="id">{{ placeholder }}</label>
      </div>
    </div>
  </div>
</template>

<script>
import { uniqueId } from 'lodash'

export default {
  name: 'DefaultInputField',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: Number,
      default: undefined,
    },
    pattern: {
      type: String,
      default: undefined,
    },
    value: {
      type: String,
      default: '',
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    validator: {
      type: String,
      required: false,
    },
    distinctive: {
      type: Boolean,
      default: false,
      required: false
    },
    required: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
      id: uniqueId('input-field-group-'),
      inputValue: this.$props.value,
      oldInputValue: '',
      invalidField: this.$props.invalid
    }
  },
  mounted() {
    this.id = uniqueId('input-field-group-');
  },
  computed: {
    computedClass () {
      return {
        invalid: this.invalidField,
      }
    },
  },
  methods: {
    focus() {
      document.querySelector(`#${this.id}`).focus()
    },

    handleClick(e) {
      this.$emit('click', e)
    },

    inputChanged (event) {
      if (this.validator) {
        switch (this.validator) {
          case 'postCode':
            this.postCodeValidation(event)
            break;
          case 'phone':
            this.phoneNumberValidation(event)
            break;
          default:
            break;
        }
      }
      this.$emit('input', event.target.value, this.id)
    },
    phoneNumberValidation (event) {
      this.inputValue = event.target.value.replace(/[^0-9\.]+/g, '')
      event.target.value = this.inputValue
      
      if (event.target.value.length >= 9) {
        this.inputValue = event.target.value.slice(0,9)
        event.target.value = event.target.value.slice(0,9)
      }

      if (this.inputValue.length >= 9) {
        this.invalidField = false
      } else {
        this.invalidField = true
      }

    },
    postCodeValidation (event) {
      this.inputValue = event.target.value.replace(/[^\d-]/g, '')
      event.target.value = this.inputValue

      if (this.inputValue.length === 1 || this.inputValue.length === 2) {
        this.inputValue = event.target.value.replace(/[^\d]/g, '')
        event.target.value = event.target.value.replace(/[^\d]/g, '')
      }
      if (this.inputValue.length === 2 && this.oldInputValue.length === 1) {
        this.inputValue += "-"
        event.target.value += "-"
      }
      if (this.inputValue.length === 3) {
        if (this.inputValue.indexOf('-') === -1){
          let tmpValue = ''
          let tmpArrayValue = Array.from(this.inputValue)

          tmpValue = tmpArrayValue[2]
          tmpArrayValue[2] = '-'
          tmpArrayValue.push(tmpValue)
          
          this.inputValue = tmpArrayValue.join('') 
        }
      }
      if (this.inputValue.length > 3) {
        let firstPart = this.inputValue.slice(0,3)
        let secondPart = this.inputValue.slice(3,this.inputValue.length)

        if (/[-]/g.test(secondPart)) {
          secondPart = secondPart.replace(/[^\d]/g, '')
          this.inputValue = firstPart + secondPart
          event.target.value = this.inputValue
        }
      }
      if(this.inputValue.length >= 6) {
        this.inputValue = event.target.value.slice(0,6)
        event.target.value = event.target.value.slice(0,6)
      }

      if (this.inputValue.length >= 6) {
        this.invalidField = false
      } else {
        this.invalidField = true
      }

      this.oldInputValue = event.target.value 
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

.input-field-wrapper {
  margin-bottom: 16px;

  .input-field-group {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  /** Input styling **/
  .text-input {
    position: relative;
    display: block;
    height: 56px;
    width: 100%;
  }

  .text-input > input {
    position: absolute;
    bottom: 0;
    display: block;
    height: 40px;
    width: 100%;
    line-height: 40px;
    border: 0;
    border-bottom: 1px solid $grey-light;
    border-radius: 0;
    outline: 0;
    background: transparent;
    color: $grey-light;
    /*   transition: all 1s ease-in-out; */
  }

  .text-input > input::placeholder {
    color: transparent;
  }

  .text-input > label {
    position: absolute;
    top: 25px;
    left: 9px;
    color: $grey-light;
    cursor: text;
    transition: all 0.2s ease-in-out;
    user-select: none;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90%;
    white-space: nowrap;
  }

  .text-input > input:focus,
  .text-input > input:not(:placeholder-shown) {
    border-bottom: 2px solid $primary;
  }

  .text-input > input:focus + label,
  .text-input > input:not(:placeholder-shown) + label {
    top: 0;
    left: 0;
    font-size: 14px;
    color: $primary;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-transition-delay: 9999s;
    -webkit-transition: color 9999s ease-out, background-color 9999s ease-out;
  }

  &.invalid {
    .text-input > input {
      border-bottom-color: $red;
    }

    .text-input > input + label {
      color: $red;
    }
  }
}
</style>
